Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var actionContainer = function (element, definition) {

        Vendd.inlineEdit.containerControlBase.apply(this, [element, definition]);

    };
    actionContainer.prototype = Object.create(Vendd.inlineEdit.containerControlBase.prototype);
    actionContainer.prototype.name = 'actionContainer';

    actionContainer.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.containerControlBase.prototype.render.apply(self); })
            .then(function() { self.element.addClass('hidden'); });

    };

    Vendd.inlineEdit.actionContainer = actionContainer;

});